import { render, staticRenderFns } from "./AdminEditView.vue?vue&type=template&id=3777cab0"
import script from "./AdminEditView.vue?vue&type=script&lang=ts"
export * from "./AdminEditView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports